import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedNavigationKeeperIdAtom } from '@/atoms/navigation';
import { DEFAULT_KEEPER_BASE_ROUTE } from '@/utils/classicLinks';
import { useKeeperNavigationItems } from './subNavigation/useKeeperNavigationItems';

export const useKeeperNavigationItem = () => {
  const { t } = useTranslation(['navigation']);
  const keeperIqId = useAtomValue(unwrappedNavigationKeeperIdAtom);
  const keeperRoute = `${DEFAULT_KEEPER_BASE_ROUTE}/${keeperIqId}`;

  return {
    id: 'keeper',
    icon: 'Goalkeeper' as const,
    label: t('crossPlatform.primary.goalkeepers'),
    subNav: useKeeperNavigationItems(),
    path: `${keeperRoute}/overview`,
  };
};
